import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import { media } from "utils/Media"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookF, faXTwitter, faInstagram, faYoutube, faTiktok } from "@fortawesome/free-brands-svg-icons"

const SocialSidebar = styled.ul`
	position: fixed;
	right: 0;
	top: 40%;
	background-color: ${props => props.theme.colors.white};
	padding: .5rem 0;
	list-style: none;
	display: none;
	z-index: 500;
	max-width: 40px;
	overflow: hidden;

	.nav-active & {
		z-index: 1;
	}

	@media ${media.md} {
		display: block;
	}

	li {
		padding-left: 0;
		&:before {
			display: none;
		}
	}

	a {
		color: ${props => props.theme.colors.tertiary};
		padding: .25rem .5rem;
		display: block;
		font-size: 1.25rem;
		text-align: center;
		
		svg {
			max-height: 20px; 
			max-width: 20px; 
		}
		
		&:hover {
			color: ${props => props.theme.colors.secondary};
		}
	}
`

const SocialGlobal = () => {
	const data = useStaticQuery(graphql`
		query SocialQuery {
			allWp {
				edges {
					node {
						...optionsFragment
					}
				}
			}
		}
	`)

	const { 
		socialFacebookGlobal,
		socialTwitterGlobal,
		socialInstagramGlobal,
		socialYoutubeGlobal,
		socialTiktokGlobal
	} = data.allWp.edges[0]?.node.options?.acfOptions
 
	return(
		<SocialSidebar>
			{socialFacebookGlobal &&
				<li>
					<a href={socialFacebookGlobal} target="_blank" rel="noopener noreferrer">
						<span className="sr-only">Facebook</span>
						<FontAwesomeIcon icon={faFacebookF} />
					</a>
				</li>
			}
			{socialTwitterGlobal &&
				<li>
					<a href={socialTwitterGlobal} target="_blank" rel="noopener noreferrer">
						<span className="sr-only">Twitter</span>
						<FontAwesomeIcon icon={faXTwitter} />
					</a>
				</li>
			}
			{socialInstagramGlobal &&
				<li>
					<a href={socialInstagramGlobal} target="_blank" rel="noopener noreferrer">
						<span className="sr-only">Instagram</span>
						<FontAwesomeIcon icon={faInstagram} />
					</a>
				</li>
			}
			{socialYoutubeGlobal &&
				<li>
					<a href={socialYoutubeGlobal} target="_blank" rel="noopener noreferrer">
						<span className="sr-only">Youtube</span>
						<FontAwesomeIcon icon={faYoutube} />
					</a>
				</li>
			}
			{socialTiktokGlobal &&
				<li>
					<a href={socialTiktokGlobal} target="_blank" rel="noopener noreferrer">
						<span className="sr-only">Tiktok</span>
						<FontAwesomeIcon icon={faTiktok} />
					</a>
				</li>
			}
		</SocialSidebar>
	)
}

export default SocialGlobal